import { DocumentPreview } from '@/components/AgentChat/DocumentPreview'
import { isTablePreviewable, type PreviewDocument } from '@/components/AgentChat/previewDocument'
import { SpreadsheetPreview } from '@/components/AgentChat/SpreadsheetPreview'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface DocumentPreviewDialogProps {
  doc: PreviewDocument
  title: string
  onOpenChange: (open: boolean) => void
}

export function DocumentPreviewDialog({ doc, title, onOpenChange }: DocumentPreviewDialogProps) {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent size="xl" className="flex h-[calc(100%-20px)] flex-col" aria-describedby={undefined}>
        <DialogHeader className="pr-8">
          <DialogTitle className="truncate">{title}</DialogTitle>
        </DialogHeader>
        {isTablePreviewable(doc.fileName) ? (
          <SpreadsheetPreview doc={doc} />
        ) : (
          <DocumentPreview doc={doc} stacked={false} />
        )}
      </DialogContent>
    </Dialog>
  )
}
